<template>
  <v-dialog
    v-model="showDialog"
    width="400px"
    @closed="handleClosed"
    @open="handleOpen">
    <div class="dialog-container">
      <div class="dialog-header">
        <p>Eidt Private Car Makes</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="handleClosed"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules">
          <div class="form-item">
            <span>Make</span>
            <v-input
              :value="make"
              disabled
            />
          </div>
          <div class="form-item">
            <span>Status</span>
            <el-form-item
              ref="status"
              prop="status"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.status"
                :list="makeStatusOptions"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="handleClosed">Cancel</v-button>
        <v-button
          green
          @click="handlerSave">Save</v-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addCarMake, getCarMakeList, updateSingleCarMake} from '@api/privateCarList'
export default {
  name: 'eidt-manage-make-dialog',
  mixins: [MixinOptions, MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    form:{
      type:Object,
      default:()=>({})
    },
    classId:{
      type:Number,
      default:11
    }
  },
  data(){
    return{
      showDialog:false,
      formData:{
        status:''
      }
    }
  },
  computed:{
    make(){
      let {make} = this.form||{}
      return make
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        if(val){
          let {status} = this.form||{}
          this.formData.status =status
        }
        this.showDialog = val
      }
    }
  },
  methods:{
    handleOpen(){

    },
    handlerSave(){
      this.network().updateCarMake()
    },
    handleClosed(){
      this.showDialog =false
      this.$emit('input',this.showDialog)
    },
    network(){
      return {
        updateCarMake: async(params) =>{
          let {id} = this.form
          params = {
            ...this.formData,
            id,
            class_id:this.classId
          }
          const {data} = await updateSingleCarMake(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
          this.$emit('refresh')
          this.showDialog = false
          this.$emit('input',this.showDialog)
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  color: #616266;

  h1 {
    font-size: 24px;
  }

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -15px;
    padding: 0 15px 15px 15px;
    border-bottom: 1px solid #dddfe7;

    h1 {
      font-size: 24px;
    }
  }
  .dialog-body{
    margin-top: 25px;
    padding-bottom: 10px;
  }
  .dialog-content {
    padding-top: 15px;

    & > div {
      flex: 1;
    }

    .left {
      margin-top: -15px;
      padding-right: 15px;
      padding-top: 15px;
      border-right: 1px solid #dddfe7;
    }

    .right {
      padding-left: 15px;
    }

    .form-box {
      margin-bottom: 10px;

      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
  }
}
</style>
